import styled from 'styled-components';

export const PageHeader = styled.header`
    font-family: var(--header-font);
    padding: 2rem 0;
`;